<mat-card>
  <form name="descriptionForm" [formGroup]="form">
    <h3>Describe your event?</h3>
    <p>A good description is vital to the success of your listing, <a (click)="openDescriptionGuidelines()">click here</a> for some examples and guidelines.</p>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <textarea class="txt-teaser" matInput required formControlName="teaser" name="event_teaser"  #teaser (focusout)="trimValue($event,'teaser')"></textarea>
          <div class="form-row__teaser" style="font-size:14px; color: rgba(0, 0, 0, 0.65);">
            You have written {{ teaser && teaser.value ? teaser.value.length : 0 }} of 250 characters
          </div>
          <mat-label>Teaser</mat-label>
          <mat-hint>This will be displayed on search listings, please provide a teaser with minimum of 100 characters and maximum of 250 characters.</mat-hint>
          <mat-error *ngIf="form.get('teaser').invalid">{{getErrorMessage('teaser')}}</mat-error>
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline">
          <textarea class="txt-description" rows="15" matInput required name="Descrition" formControlName="description" #description (focusout)="trimValue($event,'description')"></textarea>
          <div class="form-row__description" style="font-size:14px; color: rgba(0, 0, 0, 0.65);">
              You have written {{ description && description.value ? description.value.length : 0 }} of 750 characters
          </div>
          <mat-label>Description</mat-label>
          <mat-hint>Describe what your event is about, considering a minimum of 100 characters and a maximum of 750 characters.</mat-hint>
          <mat-error *ngIf="form.get('description').invalid">{{getErrorMessage('description')}}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <textarea class="txt-teaser" matInput formControlName="metadescription" name="event_metadescription" #metadescription (focusout)="trimValue($event,'metadescription')"></textarea>
          <div class="form-row__teaser" style="font-size:14px; color: rgba(0, 0, 0, 0.65);">
            You have written {{ metadescription && metadescription.value ? metadescription.value.length : 0 }} of 140 characters
          </div>
          <mat-label>Description for search engines</mat-label>
          <mat-hint>Please provide some words to help people find your event in Google search. E.g. Viking Fun – Family friendly festival happening in Dublin this July. Please provide a minimum of 25 characters and maximum of 140 characters.</mat-hint>
          <mat-error *ngIf="form.get('metadescription').invalid">{{getErrorMessage('metadescription')}}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <mat-select matInput [(value)]="value.audience" formControlName="audience" name="event_audience">
            <mat-option value="Adults Only">Adults Only</mat-option>
            <mat-option value="Children and Family">Children and Family</mat-option>
          </mat-select>
          <mat-label>Audience</mat-label>
          <mat-hint>What is the audience of the event?</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-card>